import RadioGroup from "@p-ban/common/src/components/form/radio/RadioGroup"

import ESTIMATE_CONSTANT from "../../../../../constant/estimateConstant"
import estimateField from "../../../../../service/estimateFields/estimateField"
import getDisplayCondition from "../../../../../service/getDisplayCondition"
import type { OneClickFieldProps } from "../../../../../types"
import OneClickField from "../../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../../components/1Click/form/OneClickFieldStack"
import Radio from "../../../../components/1Click/form/Radio/Radio"
import HELP_LINKS from "../../../../constant/helpLinks"

import img from "./panelized.png"

const 面付け = ({ values, handlers, errors }: OneClickFieldProps) => {
  const { panelized: shouldShow } = getDisplayCondition(values)

  return (
    <OneClickField isShow={shouldShow} legend="面付け" helpURL={HELP_LINKS["面付け"]} src={img}>
      <RadioGroup name={estimateField.panelized.key} selectedValue={values.panelized} onChange={handlers.radio}>
        <OneClickFieldStack>
          <Radio value={ESTIMATE_CONSTANT["面付け"].あり.value}>あり</Radio>
          <Radio value={ESTIMATE_CONSTANT["面付け"].なし.value}>なし</Radio>
        </OneClickFieldStack>
      </RadioGroup>
      <OneClickFieldMessages error={errors?.panelized} />
    </OneClickField>
  )
}

export default 面付け
